export const RATE_LIMIT_REQUESTS_NUMBER = 10; // 10 requests
export const RATE_LIMIT_WINDOW = 15 * 60 * 1000; // per 15 minutes;
